/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CityStateLookupDataModelApiModel } from '../../models/city-state-lookup-data-model-api-model';

export interface GetClosestToLatLng$Params {
  lng: any;
  lat: any;
}

export function getClosestToLatLng(http: HttpClient, rootUrl: string, params: GetClosestToLatLng$Params, context?: HttpContext): Observable<StrictHttpResponse<CityStateLookupDataModelApiModel>> {
  const rb = new RequestBuilder(rootUrl, getClosestToLatLng.PATH, 'get');
  if (params) {
    rb.path('lng', params.lng, {});
    rb.path('lat', params.lat, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<CityStateLookupDataModelApiModel>;
    })
  );
}

getClosestToLatLng.PATH = '/v1/lookup/closest/{lat}/{lng}';
